<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Senarai Deposit">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.no_cagaran"
                            label=" No. Akaun Cagaran"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input v-model="cari.no_fail" label="No. Fail" />
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.amaun_deposit"
                            label="Amaun Cagaran (RM)"
                        />
                    </div>

                    <div class="xs6 mr3">
                        <w-input v-model="cari.nama_id" label="Nama/ID" />
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <z-lookup
                            label="Status"
                            name="status"
                            :url="service_deposit + 'lookup/lkp_status'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_deposit_status_id"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.dari"
                            required
                            label="Tarikh "
                            type="date"
                        />
                    </div>
                    <div class="xs6 mr3">
                       <w-input
                        type="date"
                        label="Hingga"
                        name="tarikh_hingga"
                        v-model="cari.hingga">
                       </w-input>
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()" :loading="cari.loading">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>
            <br>
                <center v-if="cari.loading"><w-progress class="ma1" circle></w-progress></center>
            <z-table
                ref="tbluser"
                title="Senarai Deposit"
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >
                <!-- <template #button>
                    <w-button dark class="indigo-dark2--bg ml1" @click="newrecord()">
                        <w-icon class="mr1">fal fa-plus</w-icon> Tambah
                    </w-button>
                </template> -->
                <template #item-cell.amaun="{ item, label, header, index }">
                    <div class="text-right">
                        {{ $zutil.currency(item.amaun_deposit) }}
                    </div>
                </template>
                <template #item-cell.amaun_baki="{ item, label, header, index }">
                    <div class="text-right">
                        {{ $zutil.currency(item.amaun_baki) }}
                    </div>
                </template>
                <template #item-cell.alamat1="{ item, label, header, index }">
                    <div>
                       <template v-if="item.alamat1"> 
                        {{item.alamat1.toUpperCase()}}, 
                      </template>
                       <template v-if="item.alamat2"> 
                        {{item.alamat2.toUpperCase()}}, 
                      </template>
                       <template v-if="item.alamat3"> 
                        {{item.alamat3.toUpperCase()}}, 
                      </template>
                      <template v-if="item.poskod"> 
                        {{item.poskod.toUpperCase()}},
                        </template> 
                        <template v-if="item.bandar"> 
                        {{item.bandar.toUpperCase()}}, 
                      </template>
                      <template v-if="item.negeri"> 
                      {{item.negeri.toUpperCase()}}
                    </template>
                    </div>
                </template>
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        Tindakan
                    </template>
                </template>
                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                        <template v-if="(item.is_sediaada == 1 && item.lkp_deposit_status_id == 3)">
                           <inertia-link :href='$route("deposit.sedia_ada.semak",item.id)'>
                            <w-tooltip top>
                               <template #activator="{ on }">
                                 <w-icon v-on="on" >
                                   fal fa-pencil
                                 </w-icon>
                               </template>
                               Papar
                             </w-tooltip>
                            </inertia-link>
                        </template>
                        <template v-else>
                        <inertia-link :href="$route('deposit.show', item.id)">
                            <w-tooltip top>
                               <template #activator="{ on }">
                                 <w-icon v-on="on" >
                                   fal fa-file
                                 </w-icon>
                               </template>
                               Papar
                             </w-tooltip>
                            </inertia-link>
                        </template>
                    </w-flex>
                </template>
            </z-table>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
// import ZenOne from '@/Shared/ZenOne'
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_deposit + "deposit",
            reload: true,
            form_profil: {},
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/ihasil" },
                { label: "Deposit", route: "/deposit" },
                { label: "Senarai ", route: "/deposit/deposit" },
            ],
            cari: {
                hingga: '' ,
                no_fail: "",
                no_cagaran: "",
                amaun_deposit: "",
                nama: "",
                no_id: "",
                alamat1: "",
                lkp_deposit_status_id: "",
                nama_id: "",
                dari: "",
            },
        };
    },
    methods: {
        search() {
            this.cari.loading = true
            this.$inertia.visit(
                window.route('deposit.index') +
                    '?no_cagaran=' +
                    this.cari.no_cagaran +
                    '&no_fail=' +
                    this.cari.no_fail +
                    '&amaun_deposit=' +
                    this.cari.amaun_deposit +
                    '&nama=' +
                    this.cari.nama +
                    '&no_id=' +
                    this.cari.no_id +
                    '&alamat1=' +
                    this.cari.alamat1 +
                    '&lkp_deposit_status_id=' +
                    this.cari.lkp_deposit_status_id +
                    '&nama_id='+
                    this.cari.nama_id +
                    '&dari='+
                    this.cari.dari+
                    '&hingga='+
                    this.cari.hingga,
                { preserveScroll: true }
            );
        },

        reset() {
            this.cari = {
                no_fail: "",
                amaun_deposit: "",
                no_cagaran: "",
                nama: "",
                no_id: "",
                alamat1: "",
                lkp_deposit_status_id: "",
                nama_id: "",
                dari: "",
                hingga: "",
            };
            this.search();
        },
    },
    watch: {},
    mounted() {
        // override default setting
        // this.getData();
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.no_fail == "undefined") {
            this.cari.no_fail = "";
        }
        if (this.cari.no_cagaran == "undefined") {
            this.cari.no_cagaran = "";
        }
        if (this.cari.amaun_deposit == "undefined") {
            this.cari.amaun_deposit = "";
        }
        if (this.cari.nama == "undefined") {
            this.cari.nama = "";
        }
        if (this.cari.no_id == "undefined") {
            this.cari.no_id = "";
        }
        if (this.cari.alamat1 == "undefined") {
            this.cari.alamat1 = "";
        }
        if (this.cari.keterangan == "undefined") {
            this.cari.keterangan = "";
        }
        if (this.cari.nama_id == "undefined") {
            this.cari.nama_id = "";
        }
        if (this.cari.nama_id == "undefined") {
            this.cari.nama_id = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
